import * as React from 'react';

function SvgDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M20 20H4V4h16z" />
        <path
          d="M11.306 16.776l-6.69-6.443a.822.822 0 01-.023-1.163l.022-.022a.89.89 0 011.231 0L12 15.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z"
          fill="#00182E"
        />
      </g>
    </svg>
  );
}

export default SvgDown;
